// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Gb3fR","label":"styles_label__VotUL"};